module.exports = __webpack_public_path__ + "static/media/14.df384696.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/14.png
// module id = 1255
// module chunks = 0